import { TMargin } from '@libs/types';
import { DotLottieReact } from '@lottiefiles/dotlottie-react';
import React, { useMemo } from 'react';
import { useResolvedTheme } from '../../theme/useResolvedTheme';
import { getInlineStyles } from '../../utils/styles';
import './initWasm';
import { recolorLottie } from './recolorLottie';

type TLottieAnimationViewOldProps = {
    dataTest?: string;
    /** Parsed Lottie JSON from `src/animations/*.json`. */
    animationData: Record<string, unknown>;
    /** CSS color or versioned theme color (e.g. `semanticColorsV1[SemanticColor.IconEmphasised]`) every fill/stroke/gradient is repainted to; when omitted the animation keeps its own colors. */
    animationsColor?: string;
    loop: boolean;
    size: string;
    margin?: TMargin;
};

/**
 * v1 animation view: plays a Lottie JSON (as in master), recolored with {@link recolorLottie}.
 * master rendered it with `lottie-web`; it is gone, so the JSON goes to `DotLottieReact` through `data`.
 * Used only by the `*AnimationV1` widgets — delete together with them.
 */
export const LottieAnimationViewV1 = ({ dataTest, animationData, animationsColor, loop, size, margin }: TLottieAnimationViewOldProps) => {
    const theme = useResolvedTheme();
    const data = useMemo(
        () => (animationsColor ? recolorLottie(animationData, animationsColor, theme) : animationData),
        [animationData, animationsColor, theme],
    );

    return (
        <div data-test={dataTest} style={getInlineStyles({ margin, height: size, width: size })}>
            <DotLottieReact data={data} loop={loop} autoplay />
        </div>
    );
};
